import { render, staticRenderFns } from "./MyAddresses.vue?vue&type=template&id=4129a97e&scoped=true&"
import script from "./MyAddresses.vue?vue&type=script&lang=js&"
export * from "./MyAddresses.vue?vue&type=script&lang=js&"
import style0 from "./MyAddresses.vue?vue&type=style&index=0&id=4129a97e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4129a97e",
  null
  
)

export default component.exports